import React, { useState } from 'react';
import { PiNotePencilFill } from "react-icons/pi";
import { Modal } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import OwnToast from '../../general additions/OwnToast';
import axios from 'axios';
import { useRefresh } from '../../general additions/RefreshProvider';
import { LoadingShopPart } from '../../general additions/LoadingElements';

export default function UpdateCategory({ category_id, IsThisLicense }) {
  const { t } = useTranslation();
  const { triggerRefresh } = useRefresh();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  // Category :
  const [titleEn, setTitleEn] = useState("");
  const [titleFr, setTitleFr] = useState("");
  const [detailsEn, setDetailsEn] = useState("");
  const [detailsFr, setDetailsFr] = useState("");

  const link = IsThisLicense ? 'alllicenses' : 'allcategories';
  const link2 = IsThisLicense ? 'licenses' : 'categories';
  const type = IsThisLicense ? 'license' : 'category';

  const openTheModal = () => {
    setOpenModal(true);
    axios.get(`${localhost}/${link}/${category_id}`)
      .then((res) => {
        setTitleEn(res.data.title.en);
        setTitleFr(res.data.title.fr);
        setDetailsEn(res.data.details.en);
        setDetailsFr(res.data.details.fr);
        setLoading(false);
      }).catch((err) => console.error(err));
  }

  const handleUpdateCategory = (e) => {
    e.preventDefault();
    const categoryData = {
      title: {
        en: titleEn,
        fr: titleFr
      },
      details: {
        en: detailsEn,
        fr: detailsFr
      },
    };

    axios.put(`${localhost}/admin/${link2}/${category_id}`, categoryData, { headers: { 'Authorization': `Bearer ${token}` } })
      .then((res) => {
        OwnToast('success', t("update-" + type + "-success"));
        triggerRefresh();
        setOpenModal(false);
      })
      .catch((err) => {
        OwnToast('error', t("update-" + type + "-error"));
        console.error(err);
      });
  }

  return (
    <>
      <button onClick={openTheModal} className="flex flex-wrap gap-1 items-center text-sm bg-blue-600 hover:bg-blue-700 text-white pl-2 pr-2.5 py-1.5 max-sm:p-1.5 rounded-md">
        <PiNotePencilFill className="h-[16px] w-[16px]" />
        <span className="max-sm:hidden">{t("edit")}</span>
      </button>

      <Modal size="xl" show={openModal} onClose={() => setOpenModal(false)}>
        <Modal.Header>{t("update-" + type)}</Modal.Header>
        <form onSubmit={handleUpdateCategory}>
          {
            loading ? <div className='flex justify-center items-center h-[50vh] w-full'>
              <LoadingShopPart />
            </div>
              : <Modal.Body>
                <div>
                  <div>
                    <div className='grid grid-cols-2 gap-2 mb-6'>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-2 text-sm font-medium text-black">Title <span className='text-blue-600 text-xs'>(en)</span></label>
                        <input type="text" value={titleEn} onChange={(e) => setTitleEn(e.target.value)}
                          className="focus:ring-blue-700 focus:border-blue-700 placeholder:lowercase bg-gray-50 myborder text-black text-sm rounded-lg block w-full p-2.5" placeholder="Title" required />
                      </div>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-2 text-sm font-medium text-black">Titre <span className='text-blue-600 text-xs'>(fr)</span></label>
                        <input type="text" value={titleFr} onChange={(e) => setTitleFr(e.target.value)}
                          className="focus:ring-blue-700 focus:border-blue-700 placeholder:lowercase bg-gray-50 myborder text-black text-sm rounded-lg block w-full p-2.5" placeholder="Titre" required />
                      </div>
                    </div>

                    <div className='grid grid-cols-2 gap-2 mb-2'>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-2 text-sm font-medium text-black">Description <span className='text-blue-600 text-xs'>(en)</span></label>
                        <textarea rows="4" value={detailsEn} onChange={(e) => setDetailsEn(e.target.value)}
                          className="focus:ring-blue-700 focus:border-blue-700 placeholder:lowercase bg-gray-50 myborder text-black text-sm rounded-lg block w-full p-2.5" placeholder="description..." />
                      </div>
                      <div className="col-span-2">
                        <label className="flex flex-wrap items-center gap-1 mb-2 text-sm font-medium text-black">Description <span className='text-blue-600 text-xs'>(fr)</span></label>
                        <textarea rows="4" value={detailsFr} onChange={(e) => setDetailsFr(e.target.value)}
                          className="focus:ring-blue-700 focus:border-blue-700 placeholder:lowercase bg-gray-50 myborder text-black text-sm rounded-lg block w-full p-2.5" placeholder="description..." />
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
          }
          <Modal.Footer>
            <button type='submit' className='py-2.5 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm'>{t("save")}</button>
            <button className='py-2.5 px-4 bg-white hover:bg-gray-100 hover:text-blue-600 text-black rounded-md text-sm' onClick={() => setOpenModal(false)}>{t("cancel")}</button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}
